export default __webpack_public_path__ + "static/media/RebaseMessageLogin.7fa4b33d.svg";